import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { COMMAND_DISPATCHER_ACTION_TYPE, CommandType, CoreUiInteractionEvent } from "@obg/ngx.core";
import { TelemetryService } from "@obg/ngx.global.evo";
import { TrackingContext, TrackingMyAccountAction } from "@obg/ngx.ui.core";
import { filter, tap } from "rxjs/operators";

@Injectable({
	providedIn: "root",
})
export class AuthTelemetryEffect {
	logoutCommand$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(COMMAND_DISPATCHER_ACTION_TYPE.trigger),
				filter((x: ActionWithPayload<CommandType>) => x.payload === CommandType.Logout),
				tap(() =>
					this.telemetryService.track({
						context: TrackingContext.MyAccountInteractionContext,
						event: CoreUiInteractionEvent.UserStateChange,
						data: {
							ItemClicked: TrackingMyAccountAction.Logout,
						},
					})
				)
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private telemetryService: TelemetryService
	) {}
}
